import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Map } from 'immutable';
import { useNavigate, useParams } from 'react-router-dom';
import RepairHistory  from 'RepairHistory/RepairHistory';
import Spinner from 'components/Spinner';
import * as configuration from 'configuration';
import './RepairHistoryView.css';
import Title from 'components/Title';
import * as sharedActions from 'actions/App';
import * as constants from 'constants/App';

import RepairHistoryViewSelector from '../selectors/RepairHistoryView';

const RepairHistoryView = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const vehicleId = params.vehicleID || params.vehicleId;

    useEffect(() => {
        props.dispatch({type: constants.REPAIR_HISTORY_SCREEN_LOADED, vehicleId: vehicleId});
    }, [props.dispatch, vehicleId]);

    useEffect(() => {
        return () => {
            props.dispatch({type: constants.REPAIR_HISTORY_SCREEN_UNLOADED});
        };
    }, [props.dispatch]);

    const fetchMorePOsClicked = () => {
        props.dispatch({type: constants.REPAIR_HISTORY_SCREEN_FETCH_MORE_POS_CLICKED});
    };

    const history = {
        push: (path) => navigate(path),
        replace: (path) => navigate(path, { replace: true }),
        goBack: () => navigate(-1)
    };

    const messages = defineMessages({
        repair_history_of_vehicle: {
            id: 'repair_history_of_vehicle',
            description: 'Repair History',
            defaultMessage: `Repair History for ${props.vin8}`
        }
    });

    if (props.isfetchingData) {
        return <Spinner />;
    }

    return <div className="container-fluid repair-history__box">
        <div className="repair-history__caption">
            <Title caption={<FormattedMessage {...messages.repair_history_of_vehicle}/>}/>
        </div>
        <RepairHistory lineItems={props.vehicleRepairHistory}
            showMoreLink = {true}
            fetchRepairHistory={fetchMorePOsClicked}
            nextPageExist = {props.nextPageExist}
            returnLink = {'/po/odometer/' + vehicleId}
            history={history}
        />

    </div>;
}



export default connect(RepairHistoryViewSelector)(RepairHistoryView);